import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { FileInfo } from '../media/file'

import { RootState } from '../store'

interface DocumentInfoState {
  selectedFileName: string | null
  fileInfo: FileInfo | null
  uploadIsLoading: boolean
}

const initialState: DocumentInfoState = {
  selectedFileName: null,
  fileInfo: null,
  uploadIsLoading: false,
}

export const documentInfoSlice = createSlice({
  name: 'documentInfo',
  initialState,
  reducers: {
    setProcessDocumentSelectedFileName: (state, action: PayloadAction<string>) => {
      state.selectedFileName = action.payload
    },
    setProcessDocumentFileInfo: (state, action: PayloadAction<FileInfo>) => {
      state.fileInfo = action.payload
    },
    setProcessDocumentUploadIsLoading: (state, action: PayloadAction<boolean>) => {
      state.uploadIsLoading = action.payload
    },
    resetProcessDocumentInfo: () => initialState,
  },
})

export const { setProcessDocumentSelectedFileName, setProcessDocumentFileInfo, setProcessDocumentUploadIsLoading, resetProcessDocumentInfo } =
  documentInfoSlice.actions

export const selectProcessDocumentSelectedFileName = (state: RootState) => state.processDocument.documentInfo.selectedFileName

export const selectProcessDocumentFileInfo = (state: RootState) => state.processDocument.documentInfo.fileInfo

export const selectProcessDocumentUploadIsLoading = (state: RootState) => state.processDocument.documentInfo.uploadIsLoading
